import { Sender } from 'xstate';

import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import { LogicContext } from '../types';

export const watchBingoGamesTimer = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'FETCH_BINGO_GAMES';
      }>
    ) => {
      const { bingoGames = [] } = context;
      const firstBingoGameInfo = bingoGames[0].bingo;

      if (!firstBingoGameInfo) return;

      const timeToRefetch = firstBingoGameInfo.timeLeft * 1000;
      const timeoutToken = setTimeout(() => {
        callback({ type: 'FETCH_BINGO_GAMES' });
      }, timeToRefetch);

      return () => {
        clearTimeout(timeoutToken);
      };
    }
  );
